import request from '@/axios';

/**
 * 根据查询条件,分页展示所有待审批产品更新列表
 */
export const getPendingApprovalList = (data) => request({
    method: 'post',
    url: '/api/product/getPendingApprovalList',
    data
})

/**
 * 根据查询条件 分页展示所有已审批产品更新列表
 */
export const getApprovedList = (data) => request({
    method: 'post',
    url: '/api/product/getApprovedList',
    data
})

/**
 * 根据软件更新ID,修改软件更新审批状态和审批意见
 *  approvedStatus	
    approvedComment
    upgradeId
    approverId
 */
export const updateApprovalStatus = (data) => request({
    method: 'post',
    url: '/api/product/updateApprovalStatus',
    params: data,
})

/**
 * 通过软件更新ID查询已审批详情
 *  upgradeId
    productId
 */
export const getApprovalInfoById = (data) => request({
    method: 'get',
    url: '/api/product/getApprovalInfoById',
    params: data,
})

/**
 * 通过软件更新ID查询待审批详情
 *  upgradeId
    productId
 */
export const getPendingApprovalInfoById = (data) => request({
    method: 'get',
    url: '/api/product/getPendingApprovalInfoById',
    params: data,
})
